import { render, staticRenderFns } from "./editSpu.vue?vue&type=template&id=5568cff9&scoped=true&"
import script from "./editSpu.vue?vue&type=script&lang=js&"
export * from "./editSpu.vue?vue&type=script&lang=js&"
import style0 from "./editSpu.vue?vue&type=style&index=0&id=5568cff9&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568cff9",
  null
  
)

export default component.exports